import React from 'react'
import { BrowserRouter as Router, Route, Redirect, Switch } from 'react-router-dom'
import { Grid, Row, Col } from 'react-bootstrap'
import { isLoggedIn, shouldShowSidebar } from '../components/Auth/redux/authActions'
import Login from '../components/Auth/Login'
import Dash from '../components/dash'
import Users from '../components/UsersTab'
import Deliveries from '../components/Deliveries'
import NotFound from '../common/components/notFound'
import NewConfiguration from '../components/Configuration/NewConfiguration'
import Storage from '../components/Storage'
import CreateLock from '../components/CreateLock/CreateLock'
import DataAnalytics from '../components/DataAnalytics/DataAnalyticsContainer'
import Rental from '../components/Rental/Rental'
import Exploring from '../components/Exploring/ExploringDashboard'
import ApproveAccess from '../components/ApproveAccess/ApproveAccess'

import SideBar from '../components/SideBar/SideBar'
import UserNav from '../common/components/UserNav'

import qlocx from '../assets/qlocx.png'
import Statistics from '../components/Statistics/Statistics'
import CreateStorage from '../components/CreateStorage/CreateStorage'
import Poll from '../components/Poll/Poll'
import LanguageButton from '../common/components/LanguageButton'
import CarrierDeliveryDeviation from '../components/CarrierDeliveryDeviation'

const checkAuth = () => {
  const token = localStorage.getItem('token')
  if (!token) {
    return false
  }
  return true
}

const AuthRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      checkAuth() ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: '/login',
          }}
        />
      )
    }
  />
)

export default (props) => (
  <Router basename={window.BASE_NAME}>
    <Grid fluid style={{ height: '100%', padding: 0 }}>
      {isLoggedIn() ? (
        <Row style={{ boxShadow: 'grey 1px 1px 5px', backgroundColor: '#006e78', height: 70, position: 'fixed', position: 'sticky', top: 0, zIndex: 9999 }}>
          <Col xs={1} md={1} lg={1} style={{ textAlign: 'center', padding: 10 }}>
            {!window.isMobile ? <img src={qlocx} style={{ height: 60 * 0.8, width: 120 * 0.8 }} /> : null}
          </Col>
          <Col xs={10} md={10} lg={10}>
            &nbsp;
          </Col>
          <Col xs={1} md={1} lg={1} style={{ padding: !window.isMobile ? 20 : 0 }} className={'flex'}>
            <LanguageButton />
            <UserNav />
          </Col>
        </Row>
      ) : null}

      <Row>
        <Col xs={2} md={2} lg={1} style={{ display: shouldShowSidebar() ? 'block ' : 'none' }}>
          <SideBar />
        </Col>
        <Col xs={shouldShowSidebar() ? 10 : 12} md={shouldShowSidebar() ? 10 : 12} lg={shouldShowSidebar() ? 11 : 12} style={{ padding: '1%' }}>
          <Switch>
            <AuthRoute path="/" exact component={Dash} />
            <Route path="/login" component={Login} />
            <AuthRoute path="/UsersTab" component={Users} />
            <AuthRoute path="/deliveries/:packageId" component={Deliveries} />
            <AuthRoute path="/deliveries" component={Deliveries} />
            <AuthRoute path="/createlock" component={CreateLock} />
            <AuthRoute path="/createstorage" component={CreateStorage} />
            <AuthRoute path="/data-analytics" component={DataAnalytics} />
            <AuthRoute path="/storage/:storageId" component={Storage} />
            <AuthRoute path="/exploring" component={Exploring} />
            <AuthRoute path="/rental" component={Rental} />
            <Route path="/carrier/delivery-deviation" component={CarrierDeliveryDeviation} />
            <AuthRoute path="/carrier" component={Dash} />
            <AuthRoute path="/locks/accessrequests" component={ApproveAccess} />
            <AuthRoute path="/statistics" component={Statistics} />
            <Route path="/polls/:poll" component={Poll} />
            {/* <AuthRoute path="/rental/:rentalId" component={Rental} /> */}
            {/* <AuthRoute path="/newconfiguration" component={NewConfiguration} /> */}
            <Route path="*" component={NotFound} />
          </Switch>
        </Col>
      </Row>
    </Grid>
  </Router>
)
